import { ACTIONS } from '@core/utils/constants';

export enum DataTableState {
    NoData = 0,
    Loading = 1,
    InternalError = 2,
    Ok = 3,
}

export enum DataTableColumnType {
    Tag = 0,
    Text = 1,
    Date = 2,
    Numeric = 3,
    Boolean = 4,
    IconButton = 5,
    MenuButton = 6,
    Currency = 7,
    Switch = 8,
    Img = 9,
    Avatar = 10,
}

export interface DataTableColumn {
    name: string;
    label: string;
    displayed: boolean;
    disable_sort: boolean;
    disable_switch?: boolean;
    type: DataTableColumnType;
    attribute?: string;
    class?: string;
    format?: string;
    width?: string;
    hideOn?: string[];
    action?: ACTIONS;
    icon_action?: ButtonActions;
    menu_actions?: ButtonActions[];
    default_img?: string;
}

export const AllowedFilters = [
    DataTableColumnType.Text,
    DataTableColumnType.Date,
    DataTableColumnType.Numeric,
    DataTableColumnType.Boolean,
];

export interface ButtonActions {
    label: string;
    icon: string;
    disabled: Function;
    action: ACTIONS;
    show?: any;
}
export interface DataTableConfig {
    firstFetch?: boolean;
    mediaQuery?: boolean;
    show_sort?: boolean;
    paginator: {
        show: boolean;
        pageSize: number;
        pageIndex: number;
        pageSizeOptions: number[];
        showFirstLastButtons: boolean;
    };
    columns: DataTableColumn[];
}

export interface SortingEvent {
    column: string;
    direction: string;
}

export interface PaginationEvent {
    limit: string;
    offset: string;
}
export interface RowsAction<T> {
    action: ACTIONS;
    row: T;
}

export interface Pagination {
    limit: string;
    offset: string;
}
export interface Paginator {
    pageIndex: number;
    pageSize: number;
    pageSizeOptions: number[];
}

export interface Sorting {
    column: string;
    direction: string;
}
